export default __webpack_public_path__ + "static/media/endRound3.3446e594.mp3";